import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { Observable, of, Subject, SubscriptionLike } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { EmailComposeComponent } from '../email-compose/email-compose.component';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { DeleteBoxComponent } from '../../delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email-drafts',
  templateUrl: './email-drafts.component.html',
  styleUrls: ['./email-drafts.component.scss']
})
export class EmailDraftsComponent implements OnInit, OnDestroy {

  subGetDataPost: SubscriptionLike;
  subGetData: SubscriptionLike;
  subGetData1: SubscriptionLike;

  ApplicationID: string;
  ModuleID: string;
  SubModule: string;
  @Input() Content: any;
  content : any; 
  emailsList$: Observable<any[]>;
  dateFormat = localStorage.getItem("_Dateformate") ?? 'DD MMM YYYY';
  datetimeFormat = this.dateFormat + ' ' + localStorage.getItem("_Timeformate");
  timeFormat: any = localStorage.getItem("_Timeformate");
  isNotFoundSearchResult = false;
  action: Subject<any> = new Subject();
  keywords: string = "";
  isNewestFirst: boolean = true;
  permission: string = "";
  

  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    public appService: ApidataRequestService,
    public commonService: CommonService
  ) { }

  ngOnDestroy(): void {
    if (this.subGetData) this.subGetData.unsubscribe();
    if (this.subGetData1) this.subGetData1.unsubscribe();
    if (this.subGetDataPost) this.subGetDataPost.unsubscribe();
  }
  ngOnInit(): void {
    this.ApplicationID = this.Content.Content.ApplicationID;
    this.ModuleID = this.Content.Content.ModuleID;
    this.SubModule = this.Content.Content.SubModule;
    this.isNewestFirst = true;
    this.permission = this.Content.Content.Permission;
    this.loadMails();
  }

  close() {
    this.modalRef.dismiss();
  }

  searchMails() {
    this.isNewestFirst = true;
    let searchObj = {
      ApplicationID: this.ApplicationID,
      ModuleID: this.ModuleID,
      SubModule:this.SubModule,
      KeyWords: this.keywords,
      Folder: "D"
    }
    this.subGetDataPost = this.appService.getDataPost("api/Correspondence/SearchMails/", searchObj).subscribe(result => {
      if (result.Status && result.Data.length > 0) {
        this.isNotFoundSearchResult = false;
        this.emailsList$ = of(result.Data);
        this.emailsList$.forEach(element => {
          element.forEach(element1 => {
            element1["CreateDateTime"] = element1.SentReceivedTime;
          });
        });
      } else {
        this.isNotFoundSearchResult = true;
        this.emailsList$ = of([]);
      }
    });
  }

  clearSearch() {
    this.keywords = "";
    this.isNewestFirst = true;
    this.loadMails();
  }

  sort() {
    this.isNewestFirst = !this.isNewestFirst;
    this.emailsList$ = this.emailsList$.pipe(map((data) => {
      if (!this.isNewestFirst) {
        data.sort((a, b) => {
          return a.Sent_Recvd_Dt < b.Sent_Recvd_Dt ? -1 : 1;
        });
      }
      else {
        data.sort((a, b) => {
          return a.Sent_Recvd_Dt > b.Sent_Recvd_Dt ? -1 : 1;
        });
      }
      return data;
    }))
  }

  loadMails() {
    this.subGetData = this.subGetData = this.subGetData = this.appService.getData("api/Correspondence/GetEmails?ApplicationID=" + this.ApplicationID + "&ModuleID=" + this.ModuleID +"&SubModule="+this.SubModule+ "&folder=D").subscribe(result => {
      if (result.Status && result.Data.length > 0) {

        this.emailsList$ = of(result.Data);
        this.emailsList$.forEach(element => {
          element.forEach(element1 => {
            element1["CreateDateTime"] = element1.SentReceivedTime;
          });
        });
      } else {
        this.emailsList$ = of([]);
      }
    });
  }

  mailObj_MsgID: String = "";
  
  deleteDraftConfirm(mailObj) {
    this.mailObj_MsgID = mailObj.MsgID
    const modalRef = this.modalService.open(DeleteBoxComponent, {backdrop: false
  })   
  modalRef.componentInstance.Content={ heading: 'Confirmation', custommessage: 'Are you sure you want to delete the selected Item?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" }
    modalRef.result.then((result) => {
      if(result=="okclick")
      {
        
        this.deleteDraft(); 
        this.modalRef.close();  
        //this.modalRef.close();     
      }
    });
  }

  deleteDraft = () => {
    this.subGetData1 = this.appService.getData("api/Correspondence/DeleteDraft?emailMsgID=" + this.mailObj_MsgID).subscribe(result => {
      if (result.Status) {    
       this.commonService.SuccessBanner(result.SuccessMessage);
      ;
       //this.action.next();   
       this.modalRef.close()
        } else {        
        this.commonService.ValidationBanner(result.errMessage);      
      }
    });
  }

  openCompose(mailObj) {
    let modalRef = this.modalService.open(EmailComposeComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Compose',
      content: { ApplicationID: this.ApplicationID, ModuleID: this.ModuleID,SubModule:this.SubModule, EmailMsgObj: mailObj, MailType: "draft" }
    }
    modalRef.result.then((result) => {
      
      //this.action.next();
      this.modalRef.close();
    });
  }


}
